import { FilterItem } from './misc';
import { RequestPayload, ResponsePayload } from './request';

export interface CustomerQueryParams {
  take?: number;
  skip?: number;
  existing?: boolean;
}

export enum CustomerActions {
  FETCH_CUSTOMERS = 'FETCH_CUSTOMERS',
  FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS',
  FETCH_MORE_CUSTOMERS = 'FETCH_MORE_CUSTOMERS',
  FETCH_MORE_CUSTOMERS_SUCCESS = 'FETCH_MORE_CUSTOMERS_SUCCESS',
  FETCH_CUSTOMERS_FAIL = 'FETCH_CUSTOMERS_FAIL',
  FETCH_DETAILS = 'FETCH_DETAILS',
  FETCH_DETAILS_SUCCESS = 'FETCH_DETAILS_SUCCESS',
  SELECT_CUSTOMER = 'SELECT_CUSTOMER',

  FETCH_CUSTOMERS_FILTER = 'FETCH_CUSTOMERS_FILTER',
  FETCH_CUSTOMERS_FILTER_SUCCESS = 'FETCH_CUSTOMERS_FILTER_SUCCESS',
  FETCH_WITHDRAWALS = 'FETCH_WITHDRAWALS',
  FETCH_WITHDRAWALS_SUCCESS = 'FETCH_WITHDRAWALS_SUCCESS',
  FETCH_OLD_STOCK = 'FETCH_OLD_STOCK',
  FETCH_OLD_STOCK_SUCCESS = 'FETCH_OLD_STOCK_SUCCESS',

  CREATE_DUMMY = 'CREATE_DUMMY',
  CREATE_DUMMY_SUCCESS = 'CREATE_DUMMY_SUCCESS',
  CLEAR_DUMMY = 'CLEAR_DUMMY',
  CLEAR_DUMMY_SUCCESS = 'CLEAR_DUMMY_SUCCESS',

  TOGGLE_ARRIVAL_CONFIRMATION_STATE = 'CUSTOMER_ARTICLE:TOGGLE_ARRIVAL_CONFIRMATION_STATE',
  TOGGLE_ARRIVAL_CONFIRMATION_STATE_SUCCESS = 'CUSTOMER_ARTICLE:TOGGLE_ARRIVAL_CONFIRMATION_STATE_SUCCESS'
}

interface CustomerActionType<T, P> {
  type: T;
  payload: P;
  asyncDispatch?: any;
}

export interface Customer {
  id: string;
  company: number;
  customerNumber: string;
  customerName: string;

  addressType: number;
  addressNumber: string;

  division: string;
  isActive: boolean;

  isConsignmentWarehouse: boolean;

  isEmpty?: boolean;
  isDummy?: boolean;
  canCreateDummy?: boolean;

  settings?: {
    featureMachines?: boolean;
    featureCustomArticles?: boolean;
    fulfillThreshold?: number;
  }
}

export interface FetchSuccessCustomerPayload {
  items: Customer[];
  count: number;
}

export interface CustomersFilter {
  name: FilterItem[];
}

export interface CustomerWithdrawal {
  customerNumber: string;
  articleNumber: string;
  amount: number;
  date: string;
  coilId?: string;
}

export interface CustomerWithdrawalByStockArticle {
  customerNumber: string;
  articleNumber: string;
  amount: number;
  date: string;
}

export interface CustomerWithdrawals {
  start: string;
  end: string;
  withdrawals: CustomerWithdrawal[]
  withdrawalsByStockArticle: CustomerWithdrawalByStockArticle[]
}

export interface CustomerOldStockItem {
  date: string;
  lastWithdrawal?: string;
  customerNumber: string;
  articleNumber: string;
  articleGroup: string;
  articleDescription: string;
  coilId: string;
  amount: number;
  stock: number;
  unit: string;
  charged: boolean;
  itemId: number;
  eventId: number;
}

export interface CustomerOldStock {
  end: string;
  items: CustomerOldStockItem[]
}

export type CustomerAction =
  | CustomerActionType<typeof CustomerActions.FETCH_CUSTOMERS, RequestPayload>
  | CustomerActionType<
    typeof CustomerActions.FETCH_CUSTOMERS_SUCCESS,
    ResponsePayload<FetchSuccessCustomerPayload>
  >
  | CustomerActionType<
    typeof CustomerActions.FETCH_MORE_CUSTOMERS,
    RequestPayload
  >
  | CustomerActionType<
    typeof CustomerActions.FETCH_MORE_CUSTOMERS_SUCCESS,
    ResponsePayload<FetchSuccessCustomerPayload>
  >
  | CustomerActionType<typeof CustomerActions.FETCH_CUSTOMERS_FAIL, null>
  | CustomerActionType<typeof CustomerActions.FETCH_DETAILS, RequestPayload>
  | CustomerActionType<
    typeof CustomerActions.FETCH_DETAILS_SUCCESS,
    ResponsePayload<Customer>
  >
  | CustomerActionType<typeof CustomerActions.SELECT_CUSTOMER, Customer>
  | CustomerActionType<
    typeof CustomerActions.FETCH_CUSTOMERS_FILTER,
    RequestPayload
  >
  | CustomerActionType<
    typeof CustomerActions.FETCH_CUSTOMERS_FILTER_SUCCESS,
    ResponsePayload<CustomersFilter>
  >
  | CustomerActionType<
    typeof CustomerActions.FETCH_WITHDRAWALS_SUCCESS,
    ResponsePayload<CustomerWithdrawals>
  >
  | CustomerActionType<
    typeof CustomerActions.FETCH_OLD_STOCK_SUCCESS,
    ResponsePayload<CustomerOldStock>
  >
  | CustomerActionType<
    typeof CustomerActions.TOGGLE_ARRIVAL_CONFIRMATION_STATE,
    RequestPayload
  >
  | CustomerActionType<
    typeof CustomerActions.TOGGLE_ARRIVAL_CONFIRMATION_STATE_SUCCESS,
    ResponsePayload<CustomerOldStockItem>
  >;
